<div class="card-container">
  @for (post of posts; track post) {
    <div  class="card card-small" [ngStyle]="{'border-color': post.color}">
      @if (post.coverImageURL != '') {
        <div class="image-cover">
          <img src="{{post.coverImageURL}}" class="image"/>
        </div>
      }
      @if (post.isDownloadAvailable == true) {
        <div class="pdf-cover">
          <img src="../../assets/pdficon.png" class="pdf-icon"/>
        </div>
      }
      <div class="cover">
      </div>
      <button mat-raised-button  class="hoverbuttonOpen" (click)="showPost(post.key)">Otwórz</button>
      <img src="../../assets/remove-icon.png" class="remove-icon" (click)="removeLink(post.key)" matTooltip="Usuń linka do notatki"/>
      <div class="card-content">
        @if (post.title != '') {
          <div class="title">
            {{post.title}}
          </div>
        }
        @if (post.nameHTML != '') {
          <div [innerHTML]="post.nameHTML"  class="truncate-small">
          </div>
        }
      </div>
    </div>
  }
</div>